import { z } from 'zod';
import { alterCode } from '../alterCodes/getAlterCodesWithConditions';

export const materialAlterCode = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  boid: z.string().optional(),
  materialId: z.string(),
  alterCode: alterCode,
  measurementUnit: z.object({ code: z.string(), id: z.string(), name: z.string() }),
  measurementUnitId: z.string(),
  dimension1: z.number().optional(),
  dimension2: z.number().optional(),
  dimension3: z.number().optional(),
  shortCode: z.string().optional(),
  lotFinsh: z.string().optional(),
  lotStart: z.string().optional(),
  quantityTotalizer: z.boolean(),
  relationFactor: z.number(),
  minSalesQuantity: z.number().optional(),
  isDefault: z.boolean(),
  material: z
    .object({
      allowManualPrice: z.boolean().optional(),
      allowZeroValue: z.boolean().optional(),
      image: z.string().optional(),
    })
    .optional(),
  sequence: z.number().optional(),
});

export const getMaterialAlterCodesWithConditionsSchema = z.array(materialAlterCode);

export type GetMaterialAlterCodesWithConditionsResponse = z.infer<
  typeof getMaterialAlterCodesWithConditionsSchema
>;

export const siblingMaterialAlterCodes = z.object({
  id: z.string(),
  materialId: z.string(),
  alterCode: z.object({ code: z.string(), id: z.string(), name: z.string() }).optional(),
  relationFactor: z.number(),
  sequence: z.number().optional(),
  isDefault: z.boolean(),
  measurementUnitId: z.string(),
  measurementUnit: z.object({ code: z.string(), id: z.string(), name: z.string() }),
});

export const materialAlterCodesForSalesDocument = z.object({
  id: z.string(),
  materialId: z.string(),
  material: z
    .object({
      allowManualPrice: z.boolean().optional(),
      allowZeroValue: z.boolean().optional(),
      image: z.string().optional(),
    })
    .optional(),
  alterCode: z.object({ code: z.string(), id: z.string(), name: z.string() }).optional(),
  relationFactor: z.number(),
  sequence: z.number().optional(),
  allMaterialAlterCodes: z.array(siblingMaterialAlterCodes),
  measurementUnitId: z.string(),
  measurementUnit: z.object({ code: z.string(), id: z.string(), name: z.string() }),
});

export const getMaterialAlterCodesForSalesDocumentSchema = z.array(
  materialAlterCodesForSalesDocument
);

export type GetMaterialAlterCodesForSalesDocumentResponse = z.infer<
  typeof getMaterialAlterCodesForSalesDocumentSchema
>;
